/**
 * Manual task type emitted by the support agent when it proposes changes to a
 * SENT invoice (PO number, billing address, memo, reference) for review. Used to
 * register the definition and to route the inbox preview pane.
 */
export const INVOICE_UPDATE_REVIEW_TYPE = 'REVIEW_INVOICE_UPDATE_AGENT_OUTPUT'

/**
 * Fixed width of the editable form panel (the right column) in the review modal.
 * The left preview column flexes to fill the remaining space, mirroring the
 * customer-info review's `1fr auto` two-panel layout.
 */
export const REVIEW_FORM_PANEL_WIDTH = '480px'
